import React from "react";
import { useModalUserRemoveHook } from "./modal-user-remove-hooks";

type ContextModalUserRemove = ReturnType<typeof useModalUserRemoveHook>;

export const ModalUserRemoveContext =
  React.createContext<ContextModalUserRemove | null>(null);

export function useContextModalUserRemove() {
  const context = React.useContext(ModalUserRemoveContext);

  if (!context) {
    throw new Error(
      "useContextModalUserRemove must be used within a ContextModalUserRemoveProvider",
    );
  }

  return context;
}
